import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AlterarEntidadeRequest,
  AlterarEntidadeResponse,
  DeletarPedidoAgrupamentoRequest,
  DeletarPedidoAgrupamentoResponse,
  ListarDetalheCteRequest,
  ListarDetalheCteResponse,
  ListarPainelCteRequest,
  ListarPainelCteResponse,
  ListarStatusCteResponse,
  ReprocessarCteRequest,
  ReprocessarCteResponse,
  AprovacaoCteRequest,
  AprovacaoCteResponse
} from 'src/app/@shared/models/manifesto-embarque-painel-cte.model';

const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

const filtro = (obj: ListarPainelCteRequest | ListarDetalheCteRequest) => {
  const filter = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filter);
}

@Injectable({
  providedIn: 'root'
})
export class ManifestoEmbarquePainelCteService {
  constructor(private http: HttpClient) {}

  listarStatusCte(): Observable<ListarStatusCteResponse[]> {
    return this.http.get<ListarStatusCteResponse[]>(`PainelCTe/Status`, httpOptions)
  }

  listarPainelCte(obj?: ListarPainelCteRequest): Observable<ListarPainelCteResponse[]> {
    return this.http.get<ListarPainelCteResponse[]>(`PainelCTe/Listar?${filtro(obj)}`, httpOptions)
  }

  listarDetalheCte(obj?: ListarDetalheCteRequest): Observable<ListarDetalheCteResponse> {
    return this.http.get<ListarDetalheCteResponse>(`PainelCTe/Detalhes?${filtro(obj)}`, httpOptions)
  }

  alterarEntidade(obj?: AlterarEntidadeRequest): Observable<AlterarEntidadeResponse> {
    return this.http.post<AlterarEntidadeResponse>(`PainelCTe/AlterarEntidade`, obj, httpOptions)
  }

  reprocessarCte(obj: ReprocessarCteRequest): Observable<ReprocessarCteResponse> {
    return this.http.post<ReprocessarCteResponse>(`PainelCTe/Reprocessar`, obj, httpOptions)
  }

  aprovacaoCte(obj: AprovacaoCteRequest): Observable<AprovacaoCteResponse> {
    return this.http.post<AprovacaoCteResponse>(`PainelCTe/AprovacaoCTe`, obj, httpOptions)
  }

  deletarPedidoAgrupamento(obj: DeletarPedidoAgrupamentoRequest): Observable<DeletarPedidoAgrupamentoResponse> {
    return this.http.post<DeletarPedidoAgrupamentoResponse>(`PainelCTe/DeletarPedidoAgrupamento`, obj, httpOptions)
  }
}
